import styled, { mediaQuery, css } from 'academy-common-lib/utils/Styling';
import { footerLinks } from './footerLinks';
import { appendHubsContent } from '../../../../utils/urls';
import { getPublicLang } from 'academy-common-lib/utils/url';
import usageTracker from '../../../../utils/usageTracker';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LegalLinksList = styled(UIList).withConfig({
  displayName: "LegalLinks__LegalLinksList",
  componentId: "uwvi5r-0"
})(["display:flex;justify-content:center;flex-wrap:wrap;margin-bottom:32px !important;", " a{display:inline-block;padding:8px 16px;}"], mediaQuery('notTablet', css(["justify-content:flex-end;a{padding:0 8px;}"])));
const publicLang = getPublicLang();
const LegalLinks = () => {
  return /*#__PURE__*/_jsxs(LegalLinksList, {
    children: [/*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(UILink, {
        className: "footer-link",
        href: appendHubsContent(footerLinks.LEGAL_STUFF.hrefs[publicLang] || footerLinks.LEGAL_STUFF.hrefs.en, I18n.text(footerLinks.LEGAL_STUFF.i18nKey)),
        onClick: () => {
          usageTracker.track('navInteraction', {
            action: 'footer-legal-click'
          });
        },
        use: "unstyled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: footerLinks.LEGAL_STUFF.i18nKey
        })
      })
    }), /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(UILink, {
        className: "footer-link",
        href: appendHubsContent(footerLinks.PRIVACY_POLICY.hrefs[publicLang] || footerLinks.PRIVACY_POLICY.hrefs.en, I18n.text(footerLinks.PRIVACY_POLICY.i18nKey)),
        onClick: () => {
          usageTracker.track('navInteraction', {
            action: 'footer-privacy-click'
          });
        },
        use: "unstyled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: footerLinks.PRIVACY_POLICY.i18nKey
        })
      })
    }), /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx("span", {
        className: "hs-footer-cookie-settings",
        hidden: true,
        children: /*#__PURE__*/_jsx(UILink, {
          className: "footer-link",
          href: "#",
          onClick: () => {
            usageTracker.track('navInteraction', {
              action: 'footer-cookies-click'
            });
          },
          use: "unstyled",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.publicFooter.cookies"
          })
        })
      })
    })]
  });
};
export default LegalLinks;